<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 id="draft-invoice-title" class="mb-0">
                <i class="fa fa-fw fa-ticket mr-2" />Draft Invoice
            </h5>
            <hr />
            <b-row>
                <b-col id="invoice-details" md="6">
                    Invoice untuk <strong>{{ data.customer_name }}</strong
                    ><br />
                    Segmen harga
                    <strong>{{ parsePriceSegment(data.price_segment) }}</strong>
                    <br />
                    Dari gudang
                    <strong>{{ data.warehouse }} - {{ data.office }}</strong
                    ><br />
                    Divisi <strong>{{ data.division }}</strong
                    ><br />
                    {{ data.total_item }} barang, total Rp.
                    {{ $helper.formatThousand(data.total_price) }} <br />
                    <div
                        v-if="
                            dataFlashSale && dataFlashSale.discount_percentage
                        "
                    >
                        <hr
                            class="my-2 bg-gray-400"
                            style="width: 500px; margin: 0 0 0 0;"
                        />
                        Nama Flash Sale:
                        <strong>{{
                            dataFlashSale ? dataFlashSale.name : "-"
                        }}</strong>
                        <br />
                        Diskon Flash Sale:
                        <strong>
                            {{ dataFlashSale.discount_percentage }}%</strong
                        >
                        <br />
                        Harga setelah diskon flash sale:
                        <strong
                            >Rp.{{
                                $helper.formatThousand(
                                    total_price_after_flash_sale
                                )
                            }}</strong
                        >
                        <br />
                        Group Flash Sale:
                        <strong>{{
                            dataFlashSale && dataFlashSale.group
                                ? dataFlashSale.group.name
                                : "-"
                        }}</strong>
                    </div>
                </b-col>
                <!-- Tambahkan untuk informasi flash sale  -->
                <b-col id="invoice-actions" md="6" class="text-right">
                    <h5
                        v-if="data.over_limit_request_status != null"
                        class="font-weight-bold"
                    >
                        Request Overlimit:
                        <b-badge :variant="statusOverlimitBadge">{{
                            statusOverlimit
                        }}</b-badge>
                    </h5>
                    <b-button
                        v-if="canFlashSale"
                        id="create-flash-sale-button"
                        variant="dark"
                        class="text-white"
                        @click="$bvModal.show('m-create-flash-sale')"
                    >
                        <i class="fa fa-bolt mr-2" />
                        Flash Sale
                    </b-button>
                    <b-button
                        id="cancel-invoice-button"
                        class="mx-2"
                        variant="danger"
                        @click="promptCancelInvoice"
                    >
                        <i class="fa fa-times mr-2" />Batalkan
                    </b-button>
                    <b-button
                        id="finalize-invoice-button"
                        variant="success"
                        class=""
                        @click="finalizeInvoice"
                    >
                        <i class="fa fa-check mr-2" />Finalisasi
                    </b-button>

                    <br />
                    <b-button
                        v-if="canAdjustBarcode && data.items.length > 0"
                        id="adjustment-barcode-button"
                        variant="primary"
                        class="mt-3 mr-2"
                        @click="$bvModal.show('m-adjustment-barcode')"
                    >
                        <i class="fa fa-fw fa-refresh" />Adjust Barcode / Harga
                    </b-button>
                    <b-button
                        id="edit-customer-button"
                        variant="primary"
                        class="mt-3 "
                        @click="promptEditInvoice"
                    >
                        <i class="fa fa-pencil mr-2" />Ubah Customer
                    </b-button>
                    <b-button
                        v-if="hasChangeWarehouseInvoicePermission"
                        id="pindah-gudang-button"
                        variant="warning"
                        class="mt-3 ml-2"
                        @click="promptPindahGudang"
                    >
                        <i class="fa fa-exchange mr-2" />Pindah Gudang
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="mt-3" id="search-item-row">
                <b-col md="6" id="search-item-col">
                    <b-input-group id="search-item-input-group">
                        <b-input
                            v-model="input.noFaktur"
                            maxlength="100"
                            style="max-width: 250px"
                            placeholder="Input No. Faktur..."
                            @keydown.enter="findItem"
                            id="search-item-input"
                        />
                        <b-input-group-append
                            id="search-item-input-group-append"
                        >
                            <b-button
                                variant="dark"
                                @click="findItem"
                                id="search-item-button"
                                >Cari Barang</b-button
                            >
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <!--                 <b-col md="6" class="text-right">
                    <b-button variant="warning" @click="$bvModal.show('m-pick-price-segment')">
                        Segmen Harga: <strong>{{ parsePriceSegment(data.price_segment) }}</strong>
                    </b-button>
                </b-col> -->
            </b-row>
            <b-table
                id="invoice-items-table"
                bordered
                hover
                show-empty
                no-local-sorting
                :items="data.items"
                :fields="filteredFields"
                responsive
                class="my-3"
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty>
                    Invoice masih kosong.
                </template>
                <template v-slot:cell(barang)="row">
                    {{ row.item.type }}
                    <span v-if="row.item.year != null"
                        >({{ row.item.year }})</span
                    >
                    <div class="small text-muted">
                        {{ row.item.kind }} - {{ row.item.brand }}<br />
                        Ctt: {{ row.item.note || "-" }}
                    </div>
                </template>
                <template v-slot:cell(noFakturImei)="row">
                    {{ row.item.no_faktur_pgi }}
                    <div class="small text-muted">
                        {{ row.item.imei_sn }}<br />
                        Grade
                        <strong
                            >{{ row.item.grade }} - {{ row.item.spec }} -
                            {{
                                row.item.is_batangan ? "BATANG" : "LENGKAP"
                            }}</strong
                        ><br />
                        Kloter {{ $helper.parseDate(row.item.created) }}
                    </div>
                </template>
                <template v-slot:cell(basePrice)="row">
                    Rp. {{ $helper.formatThousand(row.item.base_price) }}
                </template>
                <template v-slot:cell(adjustment)="row">
                    <p
                        class="mb-0"
                        v-if="row.item.adjustment.negative.value != '0'"
                    >
                        Total Potongan: Rp.
                        {{
                            $helper.formatThousand(
                                row.item.adjustment.negative.value
                            )
                        }}
                    </p>
                    <p
                        class="mb-0"
                        v-if="row.item.adjustment.positive.value != '0'"
                    >
                        Total Tambahan: Rp.
                        {{
                            $helper.formatThousand(
                                row.item.adjustment.positive.value
                            )
                        }}
                    </p>
                    <p
                        class="mb-0"
                        v-if="
                            row.item.adjustment.negative.value == '0' &&
                                row.item.adjustment.positive.value == '0'
                        "
                    >
                        Rp. 0
                    </p>
                    <!-- Rp. {{ $helper.formatThousand(row.item.adjustment.negative.value) }} ({{ row.item.adjustment.negative.count }} Minus)
                    <div class="small text-muted">
                        Rp. {{ $helper.formatThousand(row.item.adjustment.positive.value) }} ({{ row.item.adjustment.positive.count }} Plus)
                    </div> -->
                    <div class="small text-muted">
                        Rp.
                        {{
                            $helper.formatThousand(
                                row.item.adjustment.price_segment
                            )
                        }}
                        ({{ parsePriceSegment(data.price_segment) }})
                    </div>
                </template>
                <template v-slot:cell(subtotal)="row">
                    Rp. {{ $helper.formatThousand(row.item.total) }}
                </template>
                <template v-slot:cell(action)="row">
                    <b-button
                        id="edit-item-button"
                        size="sm"
                        variant="warning"
                        class="mr-2"
                        v-b-tooltip.hover.top
                        title="Edit"
                        @click="promptEditItem(row.item)"
                    >
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                    <b-button
                        id="remove-item-button"
                        size="sm"
                        variant="danger"
                        v-b-tooltip.hover.top
                        title="Hapus"
                        @click="promptRemoveItem(row.item)"
                    >
                        <i class="fa fa-fw fa-times" />
                    </b-button>
                </template>
            </b-table>
        </b-card>
        <b-modal
            id="m-create-flash-sale"
            title="Flash Sale"
            centered
            no-close-on-backdrop
            hide-footer
        >
            <b-form-group
                description="Masukkan nama unik untuk flash sale. Nama ini akan digunakan sebagai identitas utama dan tidak boleh sama dengan flash sale lain."
            >
                <div>Nama Flash Sale <span style="color: red;">*</span></div>
                <b-form-input v-model="inputFlashSale.name" maxlength="100" />
            </b-form-group>
            <b-form-group>
                <div>Deskripsi <span style="color: red;">*</span></div>
                <b-form-input
                    v-model="inputFlashSale.description"
                    maxlength="100"
                />
            </b-form-group>
            <b-form-group>
                <div>Group <span style="color: red;">*</span></div>
                <multiselect
                    v-model="inputFlashSale.group"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="optGroups"
                />
            </b-form-group>
            <b-form-group>
                <div>
                    Diskon Flash Sale (%) <span style="color: red;">*</span>
                </div>
                <b-input-group append="%">
                    <b-input
                        placeholder="Masukan Diskon Flash Sale"
                        v-model="inputFlashSale.discountPercentage"
                        max="99"
                        min="1"
                    />
                </b-input-group>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button
                    v-if="isAddingFlashSale"
                    variant="danger"
                    :disabled="isRemovingFlashSale"
                    @click="removeFlashSale"
                >
                    {{
                        isRemovingFlashSale
                            ? "Menghapus..."
                            : "Hapus Flash Sale"
                    }}
                </b-button>
                <b-button
                    class="ml-2"
                    variant="primary"
                    :disabled="isSavingFlashSale"
                    @click="createFlashSale"
                >
                    {{ flashSaleButtonText }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-photo" title="Foto Barang" hide-footer>
            No. Faktur <strong>{{ activeItem.no_faktur_pgi }}</strong
            ><br />
            {{ activeItem.type }}
            <span v-if="activeItem.year != null">({{ activeItem.year }})</span>
            - {{ activeItem.brand }} - {{ activeItem.kind }} <br /><br />
            <img :src="$BASE_FILE_PATH + '/' + activeItem.photo" width="100%" />
        </b-modal>
        <b-modal
            id="m-item-to-add"
            size="xl"
            :title="
                invoiceDetailId == null
                    ? 'Penambahan Barang'
                    : 'Pengubahan Barang'
            "
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            @hide="onItemModalHide"
        >
            <ModalItemDrafting
                :noFaktur="noFakturPGI"
                :invoiceId="Number($route.params.id)"
                :invoiceDetailId="invoiceDetailId"
                @item-added="onItemAdded"
            />
        </b-modal>
        <b-modal
            id="m-finalize-discount"
            title="Finalisasi - Diskon"
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <b-form-group
                id="no-ref-group"
                label="No. Ref Invoice"
                description="Wajib diisi. No. Ref akan ditampilkan di invoice. Maks. 20 karakter."
            >
                <b-input
                    id="no-ref-input"
                    v-model="finalize.noRef"
                    maxlength="20"
                />
            </b-form-group>
            <b-form-group
                id="sold-at-group"
                label="Tanggal Penjualan"
                description="Wajib diisi. Tanggal Penjualan yang akan dimunculkan di cetakan invoice sales."
            >
                <b-input
                    id="sold-at-input"
                    v-model="finalize.soldAt"
                    type="date"
                />
            </b-form-group>
            <b-form-group
                id="discount-group"
                label="Diskon (Nominal Total)"
                description="Diskon yang diberikan dalam bentuk nominal rupiah. Melakukan pemotongan dari grand total invoice."
            >
                <b-input-group id="discount-input-group" prepend="Rp.">
                    <b-input
                        id="discount-input"
                        v-model="finalize.discount"
                        @input="sanitizeDiscount"
                        type="text"
                        step="1"
                        onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                    />
                </b-input-group>
            </b-form-group>
            <b-form-group
                v-if="!dataFlashSale || !dataFlashSale.discount_percentage"
                id="discount-percent-group"
                label="Diskon (Persentase)"
                description="Diskon yang diberikan dalam bentuk persentase. Isi dengan nol apabila tidak ada diskon. Diskon dibulatkan ke 2 bilangan desimal terdekat."
            >
                <b-input-group id="discount-percent-input-group" append="%">
                    <b-input
                        id="discount-percent-input"
                        v-model="finalize.discountPercent"
                        type="text"
                        step="1"
                        onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 44 || event.charCode == 46"
                    />
                </b-input-group>
            </b-form-group>
            <div v-else class="mb-3">
                <div class="alert alert-info mb-0">
                    <strong
                        >Diskon Flash Sale
                        {{ dataFlashSale.discount_percentage }}%</strong
                    >
                    telah otomatis diterapkan ke invoice ini.
                </div>
            </div>
            <b-form-group
                id="note-group"
                label="Catatan Invoice / Diskon (Opsional)"
            >
                <b-input
                    id="note-input"
                    v-model="finalize.note"
                    maxlength="200"
                />
            </b-form-group>
            <div class="text-right mt-4">
                <b-button
                    id="continue-button"
                    variant="primary"
                    :disabled="isSubmitting"
                    @click="moveToConfirmation"
                >
                    Lanjutkan
                </b-button>
            </div>
        </b-modal>
        <b-modal
            id="m-finalize-confirm"
            title="Finalisasi Invoice"
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            :hide-header-close="isSubmitting"
        >
            Konfirmasi akhir untuk pengukuhan invoice.
            <div class="mt-3">
                <div id="finalize-confirm-no-ref">
                    <strong>No. Ref</strong><br />
                    {{ finalData.noRef }}
                </div>
                <div id="finalize-confirm-sold-at" class="mt-3">
                    <strong>Tanggal Penjualan</strong><br />
                    {{ $helper.parseDate(finalData.sold_at) }}
                </div>
                <div id="finalize-confirm-customer" class="mt-3">
                    <strong>Customer</strong><br />
                    {{ finalData.customer }}
                </div>
                <div
                    id="finalize-confirm-note"
                    class="mt-3 w-100 w-md-75 w-lg-50 text-break"
                >
                    <strong>Catatan</strong><br />
                    {{ finalize.note || "-" }}
                </div>
                <div id="finalize-confirm-total-item" class="mt-3">
                    <strong>Total Belanja</strong><br />
                    {{ finalData.total_item }} item(s), Rp.
                    {{ $helper.formatThousand(finalData.total_price) }}
                </div>
                <div id="finalize-confirm-discount-percent" class="mt-3">
                    <strong>Diskon Persentase</strong><br />
                    {{
                        finalData.discount_percent
                            ? finalData.discount_percent + " %"
                            : 0 + " %"
                    }}
                </div>
                <div id="finalize-confirm-discount" class="mt-3">
                    <strong>Diskon Nominal</strong><br />
                    Rp.
                    {{
                        finalData.discount
                            ? $helper.formatThousand(finalData.discount)
                            : 0
                    }}
                </div>
                <div
                    id="finalize-confirm-total-price-after-discount"
                    class="mt-3"
                >
                    <strong
                        >Total Pembayaran Akhir (Setelah Dikurangi
                        Diskon)</strong
                    ><br />
                    Rp.
                    {{
                        $helper.formatThousand(
                            finalData.total_price_after_discount
                        )
                    }}
                </div>
                <div id="finalize-confirm-deposit" class="mt-3">
                    <strong>Sisa Deposit Customer</strong><br />
                    Rp. {{ $helper.formatThousand(finalData.deposit) }}
                </div>
                <div id="finalize-confirm-final-price" class="mt-3">
                    <strong>Harga Akhir (Setelah Dikurangi Deposit)</strong
                    ><br />
                    Rp. {{ $helper.formatThousand(finalData.final_price) }}
                </div>
                <div id="finalize-confirm-action" class="mt-4 text-right">
                    <b-button
                        id="finalize-confirm-button"
                        variant="primary"
                        :disabled="isSubmitting"
                        @click="execConfirmInvoice"
                    >
                        {{
                            isSubmitting
                                ? "Memproses..."
                                : "Transaksikan Invoice"
                        }}
                    </b-button>
                </div>
            </div>
        </b-modal>
        <b-modal
            id="m-pick-price-segment"
            title="Set Segmen Harga"
            centered
            size="sm"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <b-button
                id="segment-grosir-offline"
                block
                :variant="data.price_segment == 1 ? 'primary' : 'light'"
                :disabled="isSubmitting"
                @click="switchSegment(1)"
                >Grosir Offline</b-button
            >
            <b-button
                id="segment-grosir-online"
                block
                :variant="data.price_segment == 2 ? 'primary' : 'light'"
                :disabled="isSubmitting"
                @click="switchSegment(2)"
                >Grosir Online</b-button
            >
            <b-button
                id="segment-retail"
                block
                :variant="data.price_segment == 3 ? 'primary' : 'light'"
                :disabled="isSubmitting"
                @click="switchSegment(3)"
                >Retail</b-button
            >
        </b-modal>
        <b-modal id="m-pin" :title="pinTitle" centered hide-footer>
            <b-form-group id="pin-input-group" label="Masukan PIN">
                <b-input
                    type="password"
                    v-model="pin"
                    maxlength="10"
                    @keydown.enter="checkPIN"
                    autofocus
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button
                    variant="primary"
                    :disabled="isSubmitting"
                    @click="checkPIN"
                >
                    Otorisasi
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-edit" title="Ubah Customer" centered hide-footer>
            <b-form-group
                id="edit-customer-group"
                label="Invoice ditujukan untuk..."
            >
                <div id="edit-customer-select">
                    <multiselect
                        id="edit-customer-select"
                        v-model="edit.customer"
                        label="name"
                        track-by="id"
                        :internal-search="true"
                        deselect-label=""
                        select-label=""
                        :options="edit.optCustomer"
                    />
                </div>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button
                    id="save-edit-customer-button"
                    variant="primary"
                    :disabled="isSubmitting || edit.customer == null"
                    @click="confirmEditInvoice"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-pindah-gudang" title="Pindah Gudang" centered hide-footer>
            <b-form-group label="Cabang">
                <multiselect
                    v-model="pindahGudang.office"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="pindahGudang.optOffice"
                    @input="onOfficeChange"
                />
            </b-form-group>
            <b-form-group label="Gudang Tujuan">
                <multiselect
                    v-model="pindahGudang.warehouse"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="pindahGudang.optWarehouse"
                    :disabled="pindahGudang.office == null"
                />
            </b-form-group>
            <b-form-group label="Penanggung Jawab">
                <multiselect
                    v-model="pindahGudang.user"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="pindahGudang.optUser"
                    :disabled="pindahGudang.office == null"
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button
                    variant="primary"
                    :disabled="isSubmitting || pindahGudang.warehouse == null || pindahGudang.user == null"
                    @click="confirmPindahGudang"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal
            id="m-print"
            title="Cetak Invoice"
            centered
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
            hide-header-close
        >
            <div id="print-invoice-message">
                Invoice berhasil dibuat. Tekan bagian "Sinar Mutiara Cell" untuk
                mencetak.
            </div>
            <iframe
                id="invoice-print-frame"
                :src="getInvoiceLink()"
                height="300px"
                width="100%"
            />
            <div id="print-invoice-instruction">
                Pastikan invoice sudah tercetak baik sebelum menekan tombol OK.
            </div>
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button
                            id="toggle-print-size-button"
                            variant="dark"
                            :disabled="invoiceSizeCooldown"
                            @click="toggleInvoiceSize"
                        >
                            Print {{ invoiceSize == "A5" ? "A4" : "A5" }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button
                            id="finish-invoice-button"
                            variant="primary"
                            @click="finishInvoice"
                        >
                            OK
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <b-modal
            id="m-overlimit-request"
            title="Request Overlimit"
            centered
            hide-footer
        >
            <p>Apakah anda yakin ingin meminta overlimit untuk customer ini?</p>
            <b-row>
                <b-col md="12" class="text-right">
                    <b-button
                        variant="outline-primary"
                        class="mr-2"
                        @click="$bvModal.hide('m-overlimit-request')"
                    >
                        Batal
                    </b-button>
                    <b-button variant="primary" @click="requestOverlimit">
                        {{ isSubmitting ? "Menyimpan..." : "Ya" }}
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal
            id="m-adjustment-barcode"
            title="Hitung dan Cetak Ulang"
            size="md"
            no-close-on-backdrop
            centered
            no-close-on-esc
            hide-footer
            :hide-header-close="isSubmitting"
        >
            <div>
                Hitung ulang harga barang di invoice ini berdasarkan harga dasar
                terbaru?
                <div class="mt-4 text-right">
                    <b-button
                        variant="primary"
                        :disabled="isSubmitting"
                        @click="execAdjustBarcode"
                    >
                        {{
                            isSubmitting
                                ? "Menghitung ulang..."
                                : "Hitung Ulang"
                        }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ModalItemDrafting from "./ModalItemDrafting.vue";
import EnumPermissions from "@/shared/enum-permissions";

export default {
    components: {
        ModalItemDrafting
    },
    data() {
        return {
            initStatus: 0,
            isSubmitting: false,
            isSavingFlashSale: false,
            isRemovingFlashSale: false,

            noFakturPGI: "",
            invoiceDetailId: null,
            pin: "",
            pinTitle: "",
            afterPin: "",
            invoiceLink: "",
            invoiceLinkA4: "",

            data: {
                items: []
            },

            dataFlashSale: null,

            total_price_after_flash_sale: 0,

            inputFlashSale: {
                name: "",
                description: "",
                group: null,
                discountPercentage: null
            },

            createdFlashSaleId: null,
            isAddingFlashSale: false,
            optGroups: [],

            input: {
                noFaktur: ""
            },

            finalize: {
                discount: "",
                discountAll: "",
                discountPercent: "",
                dp: "",
                fullPayment: true,
                note: "",
                noRef: "",
                soldAt: "",

                totalPriceAfterDiscount: 0
            },

            finalData: {},

            fields: [
                { key: "barang", label: "Barang", sortable: true },
                {
                    key: "noFakturImei",
                    label: "No. Faktur & IMEI / SN",
                    sortable: true
                },
                { key: "basePrice", label: "Harga Dasar", sortable: true },
                {
                    key: "adjustment",
                    label: "Potongan / Tambahan Harga",
                    sortable: true
                },
                { key: "subtotal", label: "Subtotal", sortable: true },
                { key: "action", label: "Aksi" }
            ],

            activeItem: {
                id: null,
                no_faktur_pgi: "",
                photo: ""
            },

            edit: {
                customer: "",
                optCustomer: []
            },

            pindahGudang: {
                warehouse: null,
                office: null,
                user: null,
                optWarehouse: [],
                optOffice: [],
                optUser: []
            },

            sortBy: null,
            sortDesc: false,

            invoiceSize: "A5",
            invoiceSizeCooldown: false
        };
    },

    watch: {
        "finalize.dp": function(newVal) {
            let cleaned = String(newVal).replace(/\./g, "");
            let res = cleaned
                .replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => (this.finalize.dp = res));
        }
    },

    methods: {
        init() {
            this.initStatus = 0;

            let getData = this.getItems();

            let getGroups = this.$axios
                .get("master/flash-sale-groups")
                .then(res => {
                    const optGroups = [];
                    res.data.data.map(item => {
                        if (item.is_visible) {
                            optGroups.push({
                                id: item.id,
                                name: item.name
                            });
                        }
                    });
                    this.optGroups = optGroups;
                });

            let getCustomers = this.$axios
                .get("customer/selection")
                .then(res => {
                    this.edit.optCustomer = res.data.data;
                })
                .catch(error => this.$helper.parseError(this, error));

            let getOffices = this.$axios
                .get("invoice/update-warehouse", {
                    params: {
                        invoice_id: this.$route.params.id
                    }
                })
                .then(res => {
                    this.pindahGudang.optOffice = res.data.data.offices.map(item => ({
                        id: item.id,
                        name: item.name
                    }));
                })
                .catch(error => this.$helper.parseError(this, error));

            Promise.all([getData, getCustomers, getGroups, getOffices])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch(error => (this.initStatus = -1));
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        },

        getItems() {
            let param = "";

            if (!this.$helper.isBlank(this.sortBy)) {
                param += "?sortBy=" + this.sortBy;
                param += "&sortDesc=" + this.sortDesc;
            }

            return this.$axios
                .get("invoice/draft/" + this.$route.params.id + param)
                .then(res => {
                    this.data = res.data.data;
                    const fs = res.data.data.flash_sale || null;
                    this.dataFlashSale = fs;

                    this.total_price_after_flash_sale = this.data.total_after_flash_sale;
                    this.clearInputFlashSale();

                    if (fs) {
                        this.createdFlashSaleId = fs.id;
                        this.isAddingFlashSale = true;

                        this.inputFlashSale.name = fs.name || "";
                        this.inputFlashSale.description = fs.description || "";
                        this.inputFlashSale.discountPercentage =
                            fs.discount_percentage;
                        this.inputFlashSale.group = fs.group
                            ? { id: fs.group.id, name: fs.group.name }
                            : null;
                    }
                })
                .catch(error => this.$helper.parseError(this, error));
        },

        clearInputFlashSale() {
            this.createdFlashSaleId = null;
            this.isAddingFlashSale = false;
            this.inputFlashSale.id = null;
            this.inputFlashSale.name = "";
            this.inputFlashSale.description = "";
            this.inputFlashSale.discountPercentage = null;
            this.inputFlashSale.group = null;
        },

        findItem() {
            if (this.$helper.isBlank(this.input.noFaktur)) {
                return this.$helper.toastError(
                    this,
                    "Mohon mengisi nomor faktur!"
                );
            }

            this.invoiceDetailId = null;
            this.noFakturPGI = this.input.noFaktur;
            this.$bvModal.show("m-item-to-add");
        },

        promptRemoveItem(item) {
            if (this.isAddingFlashSale && this.data.items.length == 1) {
                return this.$helper.toastError(
                    this,
                    "Tidak dapat menghapus barang karena memiliki flash sale aktif."
                );
            }

            let confirmed = confirm(
                `Hapus ${item.type} (NF ${
                    item.no_faktur_pgi
                }) dari invoice ini?`
            );
            if (!confirmed) return;

            this.activeItem = item;
            this.afterPin = "cancel-item";
            this.pinTitle = "Pembatalan Barang - NF " + item.no_faktur_pgi;
            this.$bvModal.show("m-pin");
        },

        execRemoveItem() {
            let payload = {
                invoice_detail_id: this.activeItem.id,
                invoice_id: this.$route.params.id,
                pin: this.pin
            };

            this.$axios
                .post("invoice/remove-item", payload)
                .then(res => {
                    this.$helper.toastSuccess(
                        this,
                        "Barang berhasil dihapus dari invoice!"
                    );
                    this.pin = "";
                    this.init();
                })
                .catch(error => this.$helper.parseError(this, error));
        },

        onItemAdded(toastMessage) {
            this.$bvModal.hide("m-item-to-add");
            this.$helper.toastSuccess(this, toastMessage);
            this.input.noFaktur = "";
            this.noFakturPGI = "";
            this.invoiceDetailId = null;
            this.init();
        },

        promptCancelInvoice() {
            // Jika ada flash sale, tambahkan keterangan flash sale juga akan di hapus
            let isConfirmed = confirm(
                `Batalkan invoice ini? Invoice ${
                    this.dataFlashSale !== null ? "dan flash sale " : ""
                }akan dihapus serta barang-barang akan dikembalikan ke status semula!`
            );
            if (!isConfirmed) return;

            this.afterPin = "cancel-invoice";
            this.pinTitle = "Pembatalan Invoice";
            this.$bvModal.show("m-pin");
        },

        promptEditInvoice() {
            this.$bvModal.show("m-edit");
        },

        confirmEditInvoice() {
            this.afterPin = "edit-customer";
            this.pinTitle = "Perubahan Customer";
            this.$bvModal.show("m-pin");
        },

        execEditInvoice() {
            this.isSubmitting = true;
            let payload = {
                id: this.$route.params.id,
                customer_id: this.edit.customer.id
            };

            this.$axios
                .post("invoice/update-invoice-draft", payload)
                .then(res => {
                    this.$helper.toastSuccess(
                        this,
                        "Customer Invoice berhasil diubah!"
                    );
                    this.pin = "";
                    this.init();
                    this.$bvModal.hide("m-edit");
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        promptPindahGudang() {
            this.pindahGudang.office = null;
            this.pindahGudang.warehouse = null;
            this.pindahGudang.user = null;
            this.pindahGudang.optWarehouse = [];
            this.pindahGudang.optUser = [];
            this.$bvModal.show("m-pindah-gudang");
        },

        onOfficeChange() {
            this.pindahGudang.warehouse = null;
            this.pindahGudang.user = null;
            this.pindahGudang.optWarehouse = [];
            this.pindahGudang.optUser = [];

            if (this.pindahGudang.office == null) return;

            this.$axios
                .get("invoice/update-warehouse", {
                    params: { office_id: this.pindahGudang.office.id, invoice_id: this.$route.params.id }
                })
                .then(res => {
                    this.pindahGudang.optWarehouse = res.data.data.warehouses.map(item => ({
                        id: item.id,
                        name: item.name
                    }));
                    this.pindahGudang.optUser = res.data.data.users.map(item => ({
                        id: item.id,
                        name: item.name
                    }));
                })
                .catch(error => this.$helper.parseError(this, error));
        },

        confirmPindahGudang() {
            this.afterPin = "pindah-gudang";
            this.pinTitle = "Pindah Gudang";
            this.$bvModal.show("m-pin");
        },

        execPindahGudang() {
            this.isSubmitting = true;
            let payload = {
                invoice_id: this.$route.params.id,
                warehouse_id: this.pindahGudang.warehouse.id,
                user_id: this.pindahGudang.user.id
            };

            this.$axios
                .post("invoice/update-warehouse", payload)
                .then(() => {
                    this.$helper.toastSuccess(
                        this,
                        "Gudang Invoice berhasil dipindahkan!"
                    );
                    this.pin = "";
                    this.init();
                    this.$bvModal.hide("m-pindah-gudang");
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        execCancelInvoice() {
            let payload = {
                id: this.$route.params.id,
                pin: this.pin
            };

            this.$axios
                .post("invoice/cancel", payload)
                .then(_ => {
                    this.$router.push({ path: "/sales/invoice" });

                    this.$nextTick(() => {
                        this.$helper.toastSuccess(
                            this,
                            "Invoice berhasil dibatalkan!"
                        );
                    });
                })
                .catch(error => this.$helper.parseError(this, error));
        },

        finalizeInvoice() {
            if (this.data.items.length == 0) {
                return this.$helper.toastError(
                    this,
                    "Invoice masih kosong / tidak ada barang!"
                );
            }

            this.$bvModal.show("m-finalize-discount");
        },

        // moveToPaymentMethod() {

        //     if(this.$helper.isBlank(this.finalize.discount)) {
        //         return this.$helper.toastError(this, "Mohon mengisi diskon!")
        //     }

        //     let payload = this.getFinalizePayload(2)
        //     if(typeof payload === "string") return this.$helper.toastError(this, payload)

        //     this.isSubmitting = true
        //     this.$axios.post("invoice/finalize", payload).then(res => {

        //         this.$bvModal.show("m-finalize-discount")

        //     })
        //     .catch(error => this.$helper.parseError(this, error))
        //     .finally(() => this.isSubmitting = false)

        // },

        moveToConfirmation() {
            let payload = this.getFinalizePayload(2);
            if (typeof payload === "string")
                return this.$helper.toastError(this, payload);

            this.isSubmitting = true;
            this.$axios
                .post("invoice/finalize", payload)
                .then(res => {
                    this.finalize.totalPriceAfterDiscount =
                        res.data.data.total_price_after_discount;
                    this.finalData = res.data.data;
                    this.$bvModal.show("m-finalize-confirm");
                })
                .catch(error => {
                    let errMsg = "";
                    if (typeof error.response.data.error === "string") {
                        errMsg = error.response.data.error;
                    }

                    this.$helper.parseError(this, error);

                    // for check when customer has reached the limit of puitang
                    if (errMsg.includes("Piutang melebihi limit")) {
                        this.$bvModal.show("m-overlimit-request");
                    }
                })
                .finally(() => (this.isSubmitting = false));
        },

        execConfirmInvoice() {
            let isConfirmed = confirm(
                "Transaksikan invoice ini? Invoice yang sudah ditransaksikan tidak dapat dibatalkan!"
            );
            if (!isConfirmed) return;

            let payload = {
                id: this.$route.params.id,
                stage: 9,
                fullPayment: this.finalData.is_fully_paid,
                note: this.finalize.note,
                noRef: this.finalData.noRef,
                soldAt: this.finalData.sold_at,
                discount: 0.0,
                discountPercent: 0.0
            };

            if (!this.$helper.isBlank(this.finalData.discount)) {
                payload.discount = this.finalData.discount;
            }
            if (!this.$helper.isBlank(this.finalData.discount_percent)) {
                payload.discountPercent = this.finalData.discount_percent;
            }

            if (this.finalData.is_fully_paid == false) {
                payload.dp = this.finalData.dp;
            }

            this.isSubmitting = true;
            this.$axios
                .post("invoice/finalize", payload)
                .then(res => {
                    this.$bvModal.hide("m-finalize-confirm");
                    this.invoiceLink = `${this.$BASE_PRINT_FILE_PATH}/${
                        res.data.data.link
                    }`;
                    this.invoiceLinkA4 = `${this.$BASE_PRINT_FILE_PATH}/${
                        res.data.data.linka4
                    }`;
                    this.$bvModal.show("m-print");
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        finishInvoice() {
            this.$router.push({ path: "/sales/invoice" });
        },

        getInvoiceLink() {
            if (this.invoiceSize == "A5") {
                return this.invoiceLink;
            } else {
                return this.invoiceLinkA4;
            }
        },

        toggleInvoiceSize() {
            this.invoiceSizeCooldown = true;
            if (this.invoiceSize == "A5") this.invoiceSize = "A4";
            else this.invoiceSize = "A5";
            setTimeout(
                function() {
                    this.invoiceSizeCooldown = false;
                }.bind(this),
                2000
            );
        },

        createFlashSale() {
            const fsInput = this.inputFlashSale;
            if (fsInput.name.trim() == "") {
                return this.$helper.toastError(
                    this,
                    "Mohon mengisi nama flash sale!"
                );
            }

            if (fsInput.description.trim() == "") {
                return this.$helper.toastError(
                    this,
                    "Mohon mengisi deskripsi flash sale!"
                );
            }

            if (fsInput.group == null) {
                return this.$helper.toastError(this, "Mohon memilih group!");
            }

            const dp = fsInput.discountPercentage;
            if (this.$helper.isBlank(dp) || Number(dp) < 1 || Number(dp) > 99) {
                return this.$helper.toastError(
                    this,
                    "Mohon mengisi diskon flash sale dengan benar (1-99)!"
                );
            }

            if (this.data.items.length == 0) {
                return this.$helper.toastError(
                    this,
                    "Invoice masih kosong / tidak ada barang!"
                );
            }

            this.isSavingFlashSale = true;

            const payloadUpdate = {
                name: fsInput.name,
                description: fsInput.description,
                group_id: fsInput.group ? fsInput.group.id : null,
                discount_percentage: Number(fsInput.discountPercentage),
                is_active: fsInput.status
            };

            const payloadCreate = {
                ...payloadUpdate,
                invoice_id: this.$route.params.id
            };

            const res = this.createdFlashSaleId
                ? this.$axios.put(
                      `flash-sale/${this.createdFlashSaleId}`,
                      payloadUpdate
                  )
                : this.$axios.post("flash-sale", payloadCreate);

            res.then(res => {
                this.$bvModal.hide("m-create-flash-sale");
                const fs = res.data && res.data.data ? res.data.data : null;
                if (!this.createdFlashSaleId) {
                    this.createdFlashSaleId = fs.id;
                }

                this.isAddingFlashSale = true;
                this.$helper.toastSuccess(
                    this,
                    "Flash sale berhasil disimpan!"
                );

                this.dataFlashSale = {
                    discount_percentage: fs.discount_percentage,
                    name: fs.name,
                    group: fs.group
                };

                this.total_price_after_flash_sale = Math.round(
                    this.data.total_price -
                        this.data.total_price * (fs.discount_percentage / 100)
                );
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSavingFlashSale = false));
        },

        removeFlashSale() {
            let isConfirmed = confirm("Hapus flash sale dari invoice ini?");
            if (!isConfirmed) return;

            this.isRemovingFlashSale = true;

            this.$axios
                .delete(`flash-sale/${this.createdFlashSaleId}`)
                .then(_ => {
                    this.$helper.toastSuccess(
                        this,
                        "Flash sale berhasil dihapus dari invoice!"
                    );
                    this.clearInputFlashSale();
                    this.dataFlashSale = null;

                    this.$bvModal.hide("m-create-flash-sale");
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isRemovingFlashSale = false));
        },

        getFinalizePayload(stage) {
            let payload = {
                id: this.$route.params.id,
                stage: stage
            };

            if (stage >= 2) {
                // Diskon

                let discountPercent = Number(
                    this.finalize.discountPercent
                        .replace(",", ".")
                        .replace(" ", "")
                ).toFixed(2);

                if (
                    this.dataFlashSale &&
                    this.dataFlashSale.discount_percentage
                ) {
                    discountPercent = Number(
                        this.dataFlashSale.discount_percentage
                    );
                }

                if (discountPercent < 0 || discountPercent > 100) {
                    return "Diskon harus antara 0 dan 100%!";
                }

                if (this.$helper.isBlank(this.finalize.noRef)) {
                    return "Mohon mengisi No. Ref Invoice!";
                }

                if (this.$helper.isBlank(this.finalize.soldAt)) {
                    return "Mohon mengisi tanggal penjualan!";
                }

                payload.discountPercent = 0;
                payload.discount = 0;

                if (!this.$helper.isBlank(this.finalize.discount))
                    payload.discount = this.$helper.toNumber(
                        this.finalize.discount
                    );
                payload.discountPercent = discountPercent;

                if (!this.$helper.isBlank(this.finalize.discountPercent))
                    payload.discountPercent = discountPercent;

                payload.noRef = this.finalize.noRef;
                payload.soldAt = this.finalize.soldAt;
            }

            if (stage >= 3) {
                // DP dan pembayaran

                payload.fullPayment = this.finalize.fullPayment;
                if (!this.finalize.fullPayment) {
                    if (this.$helper.isBlank(this.finalize.dp)) {
                        return "Mohon mengisi jumlah DP yang akan dibayarkan!";
                    }

                    let dp = this.$helper.toNumber(this.finalize.dp);
                    if (dp <= 0) return "DP tidak boleh lebih kecil dari nol!";
                    if (dp > this.finalize.totalPriceAfterDiscount)
                        return "DP lebih besar daripada total harga! Gunakan metoda pembayaran lunas!";

                    payload.dp = dp;
                }
            }

            return payload;
        },

        promptEditItem(item) {
            this.activeItem = item;
            this.afterPin = "edit-item";
            this.pinTitle = "Edit Barang - NF " + item.no_faktur_pgi;
            this.$bvModal.show("m-pin");
        },

        execEditItem() {
            this.invoiceDetailId = this.activeItem.id;
            this.noFakturPGI = this.activeItem.no_faktur_pgi;
            this.$bvModal.show("m-item-to-add");
        },

        switchSegment(newSegment) {
            if (newSegment == this.data.price_segment) {
                return;
            }

            let isConfirmed = confirm("Ubah segmen harga untuk invoice ini?");
            if (!isConfirmed) return;

            this.isSubmitting = true;
            let payload = {
                invoice_id: this.$route.params.id,
                price_segment: newSegment
            };

            this.$axios
                .post("invoice/switch-segment", payload)
                .then(res => {
                    this.$bvModal.hide("m-pick-price-segment");
                    this.$helper.toastSuccess(
                        this,
                        "Segmen harga berhasil diubah!"
                    );
                    this.init();
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        checkPIN() {
            if (this.pin == "")
                return this.$helper.toastError(this, "PIN kosong!");

            let payload = {
                pin: this.pin
            };

            this.isSubmitting = true;
            this.$axios
                .post("invoice/check-pin", payload)
                .then(_ => {
                    this.$bvModal.hide("m-pin");

                    switch (this.afterPin) {
                        case "cancel-invoice":
                            this.execCancelInvoice();
                            break;

                        case "cancel-item":
                            this.execRemoveItem();
                            break;

                        case "edit-customer":
                            this.execEditInvoice();
                            break;

                        case "edit-item":
                            this.execEditItem();
                            this.pin = "";
                            break;

                        case "pindah-gudang":
                            this.execPindahGudang();
                            break;

                        default:
                            break;
                    }
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        parsePriceSegment(segment) {
            switch (segment) {
                case 0:
                    return "Draft";
                case 1:
                    return "Grosir Offline";
                case 2:
                    return "Grosir Online";
                case 3:
                    return "Retail";
                default:
                    return "-";
            }
        },

        sanitizeDiscount() {
            let cleaned = String(this.finalize.discount).replace(/\./g, "");
            let res = cleaned
                .replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.finalize.discount = res;
        },

        sanitizeDiscountAll() {
            let cleaned = String(this.finalize.discountAll).replace(/\./g, "");
            let res = cleaned
                .replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.finalize.discountAll = res;
        },
        requestOverlimit() {
            let payload = {
                customer_id: this.data.customer_id,
                invoice_id: this.$route.params.id
            };

            this.isSubmitting = true;
            this.$axios
                .post("overlimit-request", payload)
                .then(_ => {
                    this.$helper.toastSuccess(
                        this,
                        "Permintaan overlimit berhasil dikirim!"
                    );
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => {
                    this.isSubmitting = false;
                    this.$bvModal.hide("m-overlimit-request");
                    this.$bvModal.hide("m-finalize-discount");
                    this.getItems();
                });
        },
        execAdjustBarcode() {
            this.isSubmitting = true;
            const payload = {
                invoice_id: this.$route.params.id
            };

            this.$axios
                .post("invoice/adjust-price", payload)
                .then(() => {
                    this.$helper.toastSuccess(this, "Harga berhasil diubah!");
                    this.$bvModal.hide("m-adjustment-barcode");
                    this.getItems();
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },
        onItemModalHide() {
            if (this.invoiceDetailId != null) {
                this.init();
            }
        }
    },
    created() {
        this.init();

        let tzoffset = new Date().getTimezoneOffset() * 60000;
        let localISOTime = new Date(Date.now() - tzoffset)
            .toISOString()
            .slice(0, -1);
        this.finalize.soldAt = localISOTime.substring(0, 10);
    },
    computed: {
        hasChangeWarehouseInvoicePermission() {
            const permissions = localStorage.getItem("permissions");
            const roleName = localStorage.getItem("roleName");
            return (
                this.$helper.checkRoleNumber(EnumPermissions.CHANGE_WAREHOUSE_INVOICE.toString(), permissions) ||
                (roleName && roleName.includes('Superadmin'))
            );
        },
        filteredFields() {
            return this.fields;
        },
        isFlashSale() {
            return !!(
                this.dataFlashSale && this.dataFlashSale.discount_percentage
            );
        },
        flashSaleButtonText() {
            if (this.isSavingFlashSale) {
                return this.isAddingFlashSale ? "Memperbarui..." : "Membuat...";
            }
            return this.isAddingFlashSale
                ? "Ubah Flash Sale"
                : "Buat Flash Sale";
        },
        statusOverlimitBadge() {
            switch (this.data.over_limit_request_status) {
                case 0:
                    return "warning";
                case 1:
                    return "success";
                case 2:
                    return "danger";
                default:
                    return "warning";
            }
        },
        statusOverlimit() {
            switch (this.data.over_limit_request_status) {
                case 0:
                    return "Pending";
                case 1:
                    return "Diterima";
                case 2:
                    return "Ditolak";
                default:
                    return "Pending";
            }
        },
        canAdjustBarcode() {
            return (
                this.$helper.checkRoleNumber(
                    EnumPermissions.ADJUSTMENT_BARCODE_INVOICE.toString(),
                    localStorage.getItem("permissions")
                ) || localStorage.getItem("roleName").includes("Superadmin")
            );
        },
        canFlashSale() {
            const permissions = localStorage.getItem("permissions");
            const roleName = localStorage.getItem("roleName");
            return this.$helper.checkRoleNumber(EnumPermissions.PENJUALAN_FLASH_SALE.toString(), permissions) || (roleName && roleName.includes('Superadmin'))
        }
    }
};
</script>

<style></style>
